"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    themeColors,
    fontFamily
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _useStylesUtils.useStylesUtils)();
  const ccNmmStyle = (0, _react.useMemo)(() => {
    const ccNmm = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: pxToRem(14)
    });
    const ccNmmTitle = (0, _css.css)({
      color: themeColors?.primary.main,
      fontSize: 'inherit',
      fontWeight: 'bold',
      margin: `${pxToRem(4)} 0`
    });
    const ccNmmStepsContainer = (0, _css.css)({
      margin: pxToRem(4)
    });
    const ccNmmSteps = (0, _css.css)({
      padding: 0,
      paddingInlineStart: pxToRem(16),
      margin: 0,
      lineHeight: 1.4
    });
    const ccNmmHelpContainer = (0, _css.css)({
      marginBottom: pxToRem(4)
    });
    const ccNmmDownload = (0, _css.css)({
      display: 'inline-flex',
      alignItems: 'center',
      gap: pxToRem(4)
    });
    return {
      ccNmm,
      ccNmmTitle,
      ccNmmStepsContainer,
      ccNmmSteps,
      ccNmmHelpContainer,
      ccNmmDownload
    };
  }, [fontFamily, pxToRem, themeColors?.primary.main]);
  return {
    'cc-Nmm': ccNmmStyle.ccNmm,
    'cc-Nmm__title': ccNmmStyle.ccNmmTitle,
    'cc-Nmm__steps-container': ccNmmStyle.ccNmmStepsContainer,
    'cc-Nmm__steps': ccNmmStyle.ccNmmSteps,
    'cc-Nmm__help-container': ccNmmStyle.ccNmmHelpContainer,
    'cc-Nmm__download': ccNmmStyle.ccNmmDownload
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;